import { render, staticRenderFns } from "./ProdukHukumProgress.vue?vue&type=template&id=2be652a4"
import script from "./ProdukHukumProgress.vue?vue&type=script&lang=js"
export * from "./ProdukHukumProgress.vue?vue&type=script&lang=js"
import style0 from "./ProdukHukumProgress.vue?vue&type=style&index=0&id=2be652a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports